import styled from "styled-components";
export const StyledInfoBoxWrapper = styled.div<{
  $color: string;
  $opacity: string;
}>`
  gap: 4px;
  width: 100%;
  border-radius: 8px;
  padding-inline: 16px;
  padding-block: 12px;
  background-color: ${({ $color, $opacity }) => $color + $opacity};
  border: 1px solid ${({ $color }) => $color};
  position: relative;
`;
StyledInfoBoxWrapper.displayName = "StyledInfoBoxWrapper";
export const StyledInfoBoxHeader = styled.div<{
  $hasTitle: boolean;
}>`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${({ $hasTitle }) => ($hasTitle ? "4px" : "none")};
`;
StyledInfoBoxHeader.displayName = "StyledInfoBoxHeader";
export const StyledInfoBoxContainer = styled.div`
  display: flex;
  justify-items: space-between;
  width: 100%;
  gap: 8px;
`;
StyledInfoBoxContainer.displayName = "StyledInfoBoxContainer";
export const SyledInfoBoxInnerHeader = styled.div`
  display: flex;
`;
SyledInfoBoxInnerHeader.displayName = "SyledInfoBoxInnerHeader";
